import React from 'react'

export const NAME = 'PRODUCT_TYPE'

export const types = {
  PRODUCT_TYPE_LIST_REQUEST: `${NAME}/PRODUCT_TYPE_LIST_REQUEST`,
  PRODUCT_TYPE_LIST_SUCCESS: `${NAME}/PRODUCT_TYPE_LIST_SUCCESS`,
  PRODUCT_TYPE_LIST_FAILURE: `${NAME}/PRODUCT_TYPE_LIST_FAILURE`,
  PRODUCT_TYPE_CREATE_REQUEST: `${NAME}/PRODUCT_TYPE_CREATE_REQUEST`,
  PRODUCT_TYPE_CREATE_SUCCESS: `${NAME}/PRODUCT_TYPE_CREATE_SUCCESS`,
  PRODUCT_TYPE_CREATE_FAILURE: `${NAME}/PRODUCT_TYPE_CREATE_FAILURE`,
}

export const initialState = {
  tableColumns: [
    {
      Header: 'Название культуры',
      accessor: 'name'
    }
  ],
  productTypeList: [],
  // Список не загрузился: экран показывает «Не удалось загрузить данные» и кнопку «Повторить».
  loadError: false
}
export function reducer(state = initialState, action) {
  switch (action.type) {
    case types.PRODUCT_TYPE_LIST_REQUEST:
      return { ...state, loadError: false }
    case types.PRODUCT_TYPE_LIST_FAILURE:
      return { ...state, loadError: true }
    case types.PRODUCT_TYPE_LIST_SUCCESS:
      // An answer that could not be read comes as a SUCCESS with `error` and no data.
      if (action.error) return { ...state, loadError: true }
      return {
        ...state,
        loadError: false,
        productTypeList: action.payload
      }
    default:
      return { ...state }
  }
}